package com.sweetlime.bingeamigo.state

import com.sweetlime.bingeamigo.model.LibraryMovie
import com.sweetlime.bingeamigo.model.LibraryTvShow
import com.sweetlime.bingeamigo.model.NextEpisodeCardState
import com.sweetlime.bingeamigo.model.UserActivity

data class HomeUiState(
    val isLoading: Boolean = true,
    val isActivityLoading: Boolean = true,
    val nextEpisodeCards: List<NextEpisodeCardState> = emptyList(),
    val followingActivity: List<UserActivity> = emptyList(),
    val userMovieLibrary: Map<Int, LibraryMovie> = emptyMap(),
    val userTvLibrary: Map<Int, LibraryTvShow> = emptyMap(),
    val avatarUrl: String = "",
    val username: String = "",
    val hasUnreadNotifications: Boolean = false,
    val error: String? = null
)
